import {NgModule} from "@angular/core";
import {CalendarComponent} from "angular2-fullcalendar/src/calendar/calendar";
import {FullCalendarComponent} from "./fullcalendar.component";

@NgModule({
    declarations: [
        FullCalendarComponent,
        CalendarComponent,
    ],
    imports: [

    ],
    exports: [
        FullCalendarComponent,
    ],
})

export class FullCalendarModule {

}


// WEBPACK FOOTER //
// ./src/app/modules/fullcalendar/fullcalendar.module.ts